import APIClient from '../../../common/APIClient';
import { toggleShowAlert, displayError, SUCCESS_ALERT, MAX_ITEMS_IN_PAGE } from '../commonActions';

const FETCH_COST_CENTERS = 'FETCH_COST_CENTERS';
const SET_COST_CENTER_FIELD_CHANGE = 'SET_COST_CENTER_FIELD_CHANGE';
const SET_COST_CENTER = 'SET_COST_CENTER';
const RESET_COST_CENTER = 'RESET_COST_CENTER';
const COST_CENTER_FILTER = 'COST_CENTER_FILTER';

export const SET_COST_CENTERS_PAGINATION = 'SET_COST_CENTERS_PAGINATION';
export const RESET_COST_CENTERS_PAGINATION = 'RESET_COST_CENTERS_PAGINATION';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const fetchCostCenters = () => {
  return (dispatch, getState) => {
    client().get(
      'cost-center/list'
    ).then(json => {
      const result = json.data;
      if (result) {
        let costCenters = result.data;
        if (!costCenters.length) {
          costCenters = null;
        }
        else {
          let numItems = costCenters.length;
          let min = getState().costCenters.min;
          let max = numItems < MAX_ITEMS_IN_PAGE ? numItems : getState().clients.max;
          
          const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);
          
          dispatch({type: SET_COST_CENTERS_PAGINATION, numItems, min, max, totalPages});
        }

        dispatch({type: FETCH_COST_CENTERS, costCenters});
      }
    }).catch(error => {
      dispatch(displayError(error))
    })
  }
}

export const handleInputChange = (e, definedValue = null) => {
  return (dispatch) => {
    let value = {}
    if (!e && definedValue) {
      value = definedValue;
    }
    else {
      const id = e.target.id;
  
      value = {
        [id]: e.target.value
      }
    }

    dispatch({type: SET_COST_CENTER_FIELD_CHANGE, value})
  }
}

export const getCostCenter = (id) => {
  return (dispatch) => {
    client().get(
      'cost-center/get', {
        params: {
          id
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let costCenter = result.data;
        dispatch({type: SET_COST_CENTER, costCenter})
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const upsertCostCenter = (action = null, callback = null) => {
  return (dispatch, getState) => {
    const clientObj = getState().costCenters.costCenter;
    
    let endpoint = 'cost-center/create';
    let message = 'Cost Center has been successfully created.';

    if (action === 'UPDATE_COST_CENTER') {
      endpoint = 'cost-center/update';
      message = 'Cost Center has been successfully updated.';
    }

    client().post(
      endpoint, 
      clientObj
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
        if (callback) {
          callback();
        }
      }
    }).catch(error => {
      dispatch(displayError(error))
    })
  }
}

export const resetCostCenter = () => {
  return (dispatch) => {
    dispatch({type: RESET_COST_CENTER});
  }
}

export const filterCostCenters = (filter) => {
  return (dispatch) => {
    dispatch({type: COST_CENTER_FILTER, filter});
  }
}
